



import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';

export default defineComponent({
    components: {
        HTMLContent
    },
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    setup(props) {
        let areaBottomContent = props.product.area_bottom as string;
        const hasFAQ = areaBottomContent.includes('section-faq') && areaBottomContent.includes('pdp-accordion');
        if (hasFAQ) {
            areaBottomContent = areaBottomContent.replace('pdp-accordion', 'pdp-accordion seo-faq')
        }
        return {
            hasFAQ,
            areaBottomContent
        }
    },
})
